const LOCAL_VERSION_KEY = 'app_version';
const VERSION_CHECK_URL = '/version.json?' + Date.now(); // 防止缓存，修正拼写错误

export async function checkVersion() {
  try {
    const response = await fetch(VERSION_CHECK_URL, {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache'
      }
    });
    
    if (!response.ok) {
      console.warn('版本检查失败，响应状态:', response.status);
      return;
    }
    
    // 添加内容类型检查
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      console.warn('版本检查失败，不是JSON响应:', contentType);
      return;
    }
    
    const data = await response.json();
    const serverVersion = data.version;
    const localVersion = localStorage.getItem(LOCAL_VERSION_KEY);
    
    if (!localVersion || localVersion !== serverVersion) {
      localStorage.setItem(LOCAL_VERSION_KEY, serverVersion);
      
      // 修复confirm API使用
      if (confirm('检测到新版本，请刷新页面。建议使用更稳定的小程序版本。')) {
        if (localVersion) {
          // 清除缓存并刷新
          if ('caches' in window) {
            caches.keys().then(cacheNames => {
              return Promise.all(
                cacheNames.map(cacheName => caches.delete(cacheName))
              ).then(() => {
                window.location.reload();
              });
            });
          } else {
            window.location.reload();
          }
        }
      }
    }
  } catch (error) {
    console.error('版本检查失败:', error);
  }
}